import { TravelChatBot } from './TravelChatBot'
export default TravelChatBot
